import EthLogo from '../images/EthLogo.svg'
import ArbitrumLogo from '../images/ArbitrumLogo.svg'
import PolygonLogo from '../images/PolygonLogo.svg'
import AvalancheLogo from '../images/AvalancheLogo.svg'
import BNBLogo from '../images/BNBLogo.svg'
import { EXPLORER_URLS } from './Constants'

export interface Chain {
  name: string
  chainId: number
  symbol: string
  logo?: any
  isTestnet?: boolean
}

export const Chains = {
  Ethereum: {
    name: 'Ethereum',
    logo: EthLogo,
    chainId: 1,
    symbol: 'ETH'
  },
  BSC: {
    name: 'Binance Smart Chain',
    logo: BNBLogo,
    chainId: 56,
    symbol: 'BNB'
  },
  Avalanche: {
    name: 'Avalanche',
    logo: AvalancheLogo,
    chainId: 43114,
    symbol: 'AVAX'
  },
  Arbitrum: {
    name: 'Arbitrum',
    logo: ArbitrumLogo,
    chainId: 42161,
    symbol: 'ETH'
  },
  Mumbai: {
    name: 'PolygonTestnet',
    logo: PolygonLogo,
    chainId: 80001,
    symbol: 'POL',
    isTestnet: true
  },
  Sepolia: {
    name: 'SepoliaTestnet',
    logo: EthLogo,
    chainId: 11155111,
    symbol: 'ETH',
    isTestnet: true
  },
  Polygon: {
    name: 'Polygon',
    logo: PolygonLogo,
    chainId: 137,
    symbol: 'POL'
  }
}

const testChains = [
  Chains.Mumbai,
  Chains.Sepolia
]

export const getTestChains = (): Chain[] => {
  return testChains
}

const addressType = (network: string, initialType: 'address' | 'tx'): string => {
  if (network === 'PolkadotTestnet' || network === 'Polkadot' || network === 'PolkadotAssetHub' || network === 'PolkadotAssetHubTestnet') {
    if (initialType === 'tx') {
      return 'extrinsic'
    }
  }

  if (network === 'TronTestnet' || network === 'Tron') {
    if (initialType === 'tx') {
      return 'transaction'
    }
  }

  return initialType
}

export const formatExplorerUrl = (network: string, type: 'address' | 'tx', hash: string): string => {
  if ((network === 'TronTestnet' || network === 'Tron') && hash.startsWith('0x')) {
    hash = hash.slice(2)
  }

  const explorerUrl = EXPLORER_URLS[network]
  let url = `${explorerUrl}/${addressType(network, type)}/${hash}`

  if (network === 'SolanaDevnet') {
    url = url + '?cluster=devnet'
  }
  return url
}

export function getChainById(id: number): Chain {
  const chain = Object.values(Chains).find(chain => chain.chainId === id)

  if (!chain) {
    return {
      logo: null,
      name: 'Unknown',
      chainId: id,
      symbol: 'Unknown'
    }
  }

  return chain
}
